import { BlockBlobClient } from "@azure/storage-blob";

export async function uploadFileToBlobStorage(file: File, sasUrl: string): Promise<string> {
  if (!file) {
    throw new Error("Missing file for upload.");
  }

  const blobClient = new BlockBlobClient(sasUrl);

  try {
    await blobClient.uploadData(file, {
      blobHTTPHeaders: {
        blobContentType: file.type || "application/octet-stream",
        blobContentDisposition: `attachment; filename*=UTF-8''${encodeURIComponent(file.name)}`,
      },
    });

    return blobClient.url;
  } catch (error) {
    console.error("Failed to upload file to blob storage:", error);
    throw new Error("Upload failed. Please try again.");
  }
}

export async function deleteFileFromBlobStorage(sasUrl: string): Promise<any> {
  const blobClient = new BlockBlobClient(sasUrl);

  try {
    await blobClient.delete();

  } catch (error) {
    console.error("Failed to upload file to blob storage:", error);
    throw new Error("Upload failed. Please try again.");
  }
}